export default "__VITE_ASSET__DDmwOUH4__"